var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keep-alive',[_c(_vm.mainform,{tag:"component",attrs:{"formdata":_vm.formdata},on:{"submitcomplete":_vm.onSubmitComplete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }